import { Card, CardHeader, Box } from '@mui/material';
import { BaseOptionChart } from '../../../components/chart';
import Color from '../../../../@core/theme/palette';

import PropTypes from 'prop-types';
import merge from 'lodash/merge';
import ReactApexChart from 'react-apexcharts';

AppWebsiteVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  name: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default function AppWebsiteVisits({
  title,
  subheader,
  chartLabels,
  chartData,
  name
  // ...other
}) {
  const chartOptions = merge(BaseOptionChart(), {
    plotOptions: { bar: { columnWidth: '16%' } },
    fill: { type: chartData.map((i) => i.fill) },
    labels: chartLabels,
    xaxis: { type: 'datetime' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} ${name}`;
          }
          return y;
        }
      }
    }
  });
  return (
    <Card>
      <CardHeader
        style={{ color: Color.primary.contrastText }}
        title={title}
        subheader={subheader}
      />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart
          style={{ BackgroundColor: '#000' }}
          type="line"
          series={chartData}
          options={chartOptions}
          height={364}
        />
      </Box>
    </Card>
  );
}
